"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _UICheckbox = _interopRequireDefault(require("UIComponents/input/UICheckbox"));

var _UITextInput = _interopRequireDefault(require("UIComponents/input/UITextInput"));

var MINIMUM_ELAPSED_TIME = 7;
var MAXIMUM_ELAPSED_TIME = 8388;

var _default = _react.default.createClass({
  displayName: "DynoElapsedTimeInput",
  propTypes: {
    helpText: _react.default.PropTypes.node,
    initialValue: _react.default.PropTypes.number.isRequired,
    onChange: _react.default.PropTypes.func.isRequired
  },
  getInitialState: function getInitialState() {
    var initialValue = this.props.initialValue;
    return {
      enabled: initialValue > 0,
      value: this.calcElapsedTimeValue(initialValue)
    };
  },
  langKey: function langKey(suffix) {
    return "leadFlowEditor.leadFlowOptionsEditor.elapsedTimeInput." + suffix;
  },
  calcElapsedTimeValue: function calcElapsedTimeValue(intValue) {
    if (intValue < MINIMUM_ELAPSED_TIME) {
      return MINIMUM_ELAPSED_TIME;
    }

    if (intValue > MAXIMUM_ELAPSED_TIME) {
      return MAXIMUM_ELAPSED_TIME;
    }

    return intValue;
  },
  handleToggleEnabled: function handleToggleEnabled(_ref) {
    var checked = _ref.target.checked;
    this.setState({
      enabled: checked
    });

    if (!checked) {
      this.props.onChange(0);
    } else {
      this.props.onChange(this.state.value);
    }
  },
  handleInputChange: function handleInputChange(_ref2) {
    var value = _ref2.target.value;
    var intValue = parseInt(value, 10);
    this.setState({
      value: intValue
    });
    this.props.onChange(intValue);
  },
  handleInputBlur: function handleInputBlur(_ref3) {
    var value = _ref3.target.value;
    var intValue = parseInt(value, 10);
    var parsedValue = this.calcElapsedTimeValue(intValue);
    this.setState({
      value: parsedValue
    });
    this.props.onChange(parsedValue);
  },
  render: function render() {
    return _react.default.createElement("div", {
      className: "elapsed-time-input"
    }, _react.default.createElement(_UICheckbox.default, {
      className: "p-top-1",
      alignment: 'center',
      checked: this.state.enabled,
      onChange: this.handleToggleEnabled
    }, _react.default.createElement(_FormattedMessage.default, {
      message: this.langKey('afterElapsedTime')
    }), _react.default.createElement(_UITextInput.default, {
      type: "number",
      min: MINIMUM_ELAPSED_TIME,
      value: this.state.value.toString(),
      readOnly: false,
      onChange: this.handleInputChange,
      onBlur: this.handleInputBlur,
      disabled: !this.state.enabled,
      className: "elapsed-time-input__time"
    }), _react.default.createElement(_FormattedMessage.default, {
      message: this.langKey('seconds')
    }), ' ', this.props.helpText));
  }
});

exports.default = _default;
module.exports = exports.default;